import { useState } from "react";
import { Package } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ArticleManager } from "./ArticleManager";

interface ArticlesSectionProps {
  gymId: string;
}

export const ArticlesSection = ({ gymId }: ArticlesSectionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!isOpen) {
    return (
      <Button variant="outline" className="gap-2" onClick={() => setIsOpen(true)}>
        <Package className="h-4 w-4" />
        Gestionar artículos
      </Button>
    );
  }

  return (
    <div className="bg-card border rounded-xl p-4 sm:p-6 space-y-4 w-full">
      <ArticleManager gymId={gymId} onBack={() => setIsOpen(false)} />
    </div>
  );
};
